import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import PreviewPage from '../../../../components/Editor/PreviewPagesSpread/PreviewPage';
import { getPageHtmlPath, getClientAndResourceIds } from '../../utils/helpers';
import UrlUtils from '../../../../utils/url';

interface PreviewPageOwnProps {
	page: number;
}

const mapStateToProps = (state: StoreState, { page }: PreviewPageOwnProps) => {
	const {
		galleryInfos: { config },
		editor: {
			paths: { imagePath },
			version,
		},
	} = state;
	const { tempGId: resourceId } = getClientAndResourceIds();

	return {
		src: UrlUtils.getEditorResourceUrl(config, resourceId, `${getPageHtmlPath(imagePath, page)}?version=${version}`),
	};
};

export default connect(mapStateToProps)(PreviewPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/PreviewPagesSpread/PreviewPage/index.tsx